var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length)?_c('data-selector',_vm._b({attrs:{"searchable":"","label-key":"name","value-key":"id"},on:{"input":_vm.setCountry}},'data-selector',{ items: _vm.items, value: _vm.value, error: _vm.error, disabled: _vm.disabled, required: _vm.required },false),[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }